<main class="grow" role="content">
  <div
    [class]="'kt-container-fixed py-5 lg:py-7.5 ' + containerClass"
    [style.max-width]="wide ? 'min(1800px, calc(100vw - 1rem))' : null"
    [style.width]="wide ? '100%' : null"
  >
    <div class="kt-card">
      <div class="kt-card-header flex items-center justify-between gap-3">
        <h1 class="kt-card-title">{{ title }}</h1>
        <a class="kt-btn kt-btn-sm kt-btn-light" routerLink="/catalogs">
          Back to Catalogs
        </a>
      </div>

      <div class="kt-card-content flex flex-col gap-4 p-5 lg:p-7.5">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</main>
